import { GlobalOutlined } from '@ant-design/icons';
import { Document } from 'interfaces/documents';
import { useModal } from 'hooks/useModal';
import { MenuItemType } from 'antd/es/menu/interface';

export const PublicLink = (
    row: Document,
    fetchData: () => void,
): MenuItemType => {
    const { openModal } = useModal();

    return {
        key: 'PublicLink',
        label: 'Public link',
        onClick: () => {
            openModal('publicLinkModal', {
                document: row,
            }, {
                onChange: () => {
                    fetchData();
                },
            });
        },
        icon: <GlobalOutlined />,
    };
};
